import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import axios from "axios";
import { API, getAuthHeaders } from "../../App";
import { toast } from "sonner";

export function ExportButton({ endpoint, filename, label = "Export CSV" }) {
  const handleExport = async () => {
    try {
      const response = await axios.get(`${API}${endpoint}?format=csv`, {
        headers: getAuthHeaders(),
        responseType: "blob",
      });
      const url = URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "export.csv";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Export downloaded");
    } catch {
      toast.error("Export failed");
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleExport}
      className="rounded-none border-[#E2E8F0] text-sm"
      data-testid="export-csv-button"
    >
      <Download size={14} className="mr-1" /> {label}
    </Button>
  );
}
